module.exports = __webpack_public_path__ + "img/2021_3_1_city_hair_960x899.b6a0c7f9.jpg";